import { render } from "./budget-detail.vue?vue&type=template&id=1dcb6adc&scoped=true"
import script from "./budget-detail.vue?vue&type=script&lang=js"
export * from "./budget-detail.vue?vue&type=script&lang=js"

import "./budget-detail.vue?vue&type=style&index=0&id=1dcb6adc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dcb6adc"]])

export default __exports__